import { writable } from "svelte/store";

const initPage = () => {
    const { subscribe, update, set } = writable({url:"/menu",referrer:"/"});
    return {
        subscribe,
        update,
        set,
        route: url => update( current => { 
            window.location.replace(`#` + url);
            return {url: url, referrer: current.url} ;
        }),
        back: url => update( current => { 
            url = url.split('?').length > 1 ? `${url}&back_nav=true` : `${url}?back_nav=true`;
            window.location.replace(`#` + url);
            return {url: url, referrer: current.url} ;
        }),
        referrer: () => update( current => { 
            return {url: current.referrer.split('?').length > 1 ? `${current.referrer}&back_nav=true` : `${current.referrer}?back_nav=true`, referrer: current.referrer}
        }),
        modal: modal => update( current => { return {url: current.url, referrer: current.referrer} }),
        close: () => update( current => { return {url: current.url, referrer: current.referrer} })
    }
}

export const page = initPage();

const initModal = () => {
    const { subscribe, update, set } = writable({open: false, url:'/new-retailer'});
    return {
        subscribe,
        update,
        set,
        open: route => update( current => { return {open: true, url:route} }),
        close: () => update( current => { return {open: false, url:false} }),
        preload: () => {},
        show: () => {}
    }
}

export const modal = initModal();